import * as $ from "jquery";
import { EditControl } from "../forms/form-row";
import { Google } from "./google-maps";
import { Txt } from "../common/text";
import { GoogleMapsModal } from "./google-maps-modal";

export class MapRowControl implements EditControl
{
    private container!: HTMLDivElement;
    private input!: HTMLButtonElement;
    private modal!: HTMLDivElement;
    private place: { placeId?: string; lat: number; lng: number; formattedAddress: string } | null = null;
    private changeActions: (() => void)[] = [];

    initialize(parent: HTMLElement)
    {
        this.container = document.createElement("div");
        this.container.classList.add("map-row-control");
        parent.append(this.container);

        this.input = document.createElement("button");
        this.input.type = "button";
        this.input.textContent = Txt.selectLocation;
        this.input.className = "btn btn-primary";
        this.input.onclick = () => this.openModal();
        this.container.append(this.input);

        this.modal = document.createElement("div");
        this.modal.className = "modal fade";
        document.body.appendChild(this.modal);
    }

    private openModal()
    {
        const modal = new GoogleMapsModal(this.modal, this.place);

        modal.showModal(
            place =>
            {
                this.place = place;
                this.input.textContent = place?.formattedAddress ?? Txt.selectLocation;
                this.changeActions.forEach(fn => fn());
            },
            () =>
            {
                this.place = null;
                this.input.textContent = Txt.selectLocation;
                this.changeActions.forEach(fn => fn());
            },
        );
    }

    async setValue(value: string)
    {
        if (!value || value.trim() === "" || value === "||")
        {
            this.place = null;
            this.input.textContent = Txt.selectLocation;
            return;
        }

        if (value.startsWith("|"))
        {
            value = value.substring(1);
        }
        if (value.endsWith("|"))
        {
            value = value.substring(0, value.length - 1);
        }

        const parts = value
            .split("|")
            .map(v =>
                v
                    .replace(/\*\*/g, "|")
                    .replace(/\* /g, "*"));

        const lat = parseFloat(parts[0] || "0");
        const lng = parseFloat(parts[1] || "0");
        const formattedAddress = parts[3] || "";
        const placeId = parts[4] || "";

        this.place = {
            lat,
            lng,
            formattedAddress,
            placeId
        };

        this.input.textContent = formattedAddress || Txt.selectLocation;
    }

    getValue()
    {
        if (!this.place)
        {
            return "";
        }

        const values = [
            this.place.lat.toString(),
            this.place.lng.toString(),
            this.place.formattedAddress ?? "",
            this.place.formattedAddress ?? "",
            this.place.placeId ?? ""
        ];

        return "|" + values.map(v =>
            v.replace(/\*/g, "* ").replace(/\|/g, "**")).join("|") + "|";
    }

    onChange(action: () => void)
    {
        this.changeActions.push(action);
    }

    validate()
    {
        return true;
    }

    focus()
    {
        this.input.scrollIntoView({ behavior: "smooth", block: "center" });
    }
}
